import React, { useEffect, useState } from 'react';
import { NavLink } from 'react-router-dom';
//import { disconnectWalletLiveButton, connectWalletLiveButton, getIsWalletActiveLive, getIsWalletActive, disconnectWalletButton, connectWalletButton } from '../../utils/wallet';
import { disconnectWalletLiveButton, connectWalletLiveButton, getIsWalletActiveLive, getIsWalletActive } from '../../utils/wallet';
import '../assets/elgocBold.otf';
//import homeLogo from '../assets/homelogo.png'
import { Navbar, Container } from 'react-bootstrap';

const Navbarz = () => {

    const [showConnectButton, setShowConnectButton] = useState(true);
    const [showConnectLiveButton, setShowConnectLiveButton] = useState(true);

    // Sticky Menu Area
    useEffect(() => {
        window.addEventListener('scroll', isSticky);
        return () => {
            window.removeEventListener('scroll', isSticky);
        };
    });

    useEffect(() => {
        const func = async () => {
            const isWalletActive = await getIsWalletActiveLive();
            if (isWalletActive) {
                console.log('~isWalletActive true');
                setShowConnectLiveButton(false);
            } else {
                console.log('~isWalletActive false');
                setShowConnectLiveButton(true);
            }
        }
        func();
        return;
    }, [showConnectLiveButton]);


    useEffect(() => {
        const func = async () => {
            const isWalletActive = await getIsWalletActive();
            if (isWalletActive) {
                console.log('~isWalletActive true');
                setShowConnectButton(false);
            } else {
                console.log('~isWalletActive false');
                setShowConnectButton(true);
            }
        }
        func();
        return;
    }, [showConnectButton]);


    /* Method that will fix header after a specific scrollable */
    const isSticky = (e) => {
        const header = document.querySelector('.header-area');
        const scrollTop = window.scrollY;
        scrollTop >= 250 ? header.classList.add('is-sticky') : header.classList.remove('is-sticky');
    };
    return (
        <>
            <header className="header-area header-sticky">
                <div className="container">
                    <div className="row">
                        <div className="col-12">


                            <Navbar bg="light" expand="lg">
                                <Container>
                                    <Navbar.Toggle aria-controls="basic-navbar-nav" />
                                    <Navbar.Collapse id="basic-navbar-nav">

                                        <nav className="main-nav">

                                            {/* <a href="index.html" className="logo">
                                    Nightmare Market
                                </a> 
                                <ul className="nav d-flex justify-content-center flex-nowrap" id="navbarHolder">
                                */}

                                            <ul className="nav d-flex justify-content-center flex-nowrap" id="navbarHolder">
                                                {/* <li className="nav-item">
                                                    <NavLink className="nav-link active" aria-current="page" to="/">
                                                        <img src={homeLogo} className="logohome" alt="HOME" />
                                                    </NavLink>
                                </li> */}
                                                <li className="nav-item">
                                                    <NavLink className="nav-link" to="/">
                                                        Home
                                                    </NavLink>
                                                </li>
                                                <li className="nav-item">
                                                    <NavLink className="nav-link" to="/faqs">
                                                        FAQs
                                                    </NavLink>
                                                </li>
                                                {/* <li className="nav-item">
                                        <NavLink className="nav-link" to="/mint">
                                            Mint NFTs
                                        </NavLink>
                                    </li> */}
                                                {/* <li className="nav-item">
                                        <NavLink className="nav-link" to="/list">
                                            Waiting List
                                        </NavLink>
                                    </li> */}
                                                <li className="nav-item">
                                                    <NavLink className="nav-link" to="/signup">
                                                        Signup
                                                    </NavLink>
                                                </li>
                                                {/* <li className="nav-item">
                                        <NavLink className="nav-link" to="/claim">
                                            Claim
                                        </NavLink>
                                    </li> */}
                                                <li className="nav-item">
                                                    <NavLink className="nav-link" to="/account">
                                                        Account
                                                    </NavLink>
                                                </li>
                                                {/* <li className="nav-item">
                                                    <NavLink className="nav-link" to="/gallery">
                                                        Nightmares
                                                    </NavLink>
                                                </li> */}
                                                <li className="nav-item">
                                                    <NavLink className="nav-link" to="/nightmares">
                                                        Nightmares
                                                    </NavLink>
                                                </li>
                                                <li className="nav-item">
                                                    <NavLink className="nav-link" to="/market">
                                                        Market
                                                    </NavLink>
                                                </li>
                                                {/* <li className="nav-item">
                                        <NavLink className="nav-link" to="/players">
                                            Players
                                        </NavLink>
                                    </li> */}
                                                <li className="nav-item">
                                                    {showConnectLiveButton ?
                                                        <button className="btn main-button-red-submit" onClick={() => {
                                                            connectWalletLiveButton()
                                                        }}>SYNC
                                                        </button>
                                                        :
                                                        <button className="btn main-button-red-submit" onClick={() => {
                                                            disconnectWalletLiveButton()
                                                        }}>UNSYNC
                                                        </button>}
                                                </li>
                                                {/* <li className="nav-item">
                                        {showConnectButton ?
                                            <button className="btn main-button-red-submit" onClick={() => {
                                                connectWalletButton()
                                            }}>SYNC
                                            </button>
                                            :
                                            <button className="btn main-button-red-submit" onClick={() => {
                                                disconnectWalletButton()
                                            }}>UNSYNC
                                            </button>}
                                    </li> */}

                                            </ul>
                                        </nav>


                                    </Navbar.Collapse>
                                </Container>
                            </Navbar>

                        </div>
                    </div>
                </div>
            </header>


        </>


    );
};

export default Navbarz;





/*         <ul className="nav">
            <li className="nav-item">
                <NavLink className="nav-link active" aria-current="page" to="/">
                    Home
                </NavLink>
            </li>
            { <li className="nav-item">
                <NavLink className="nav-link" to="/mint">
                    Mint NFTs
                </NavLink>
            </li>}
            <li className="nav-item">
                <NavLink className="nav-link" to="/signup">
                    Sign up
                </NavLink>
            </li>
            <li className="nav-item">
                <NavLink className="nav-link" to="/claim">
                    Claim
                </NavLink>
            </li>
            <li className="nav-item">
                <NavLink className="nav-link" to="/account">
                    Account
                </NavLink>
            </li>
            <li className="nav-item">
                <NavLink className="nav-link" to="/gallery">
                    Gallery
                </NavLink>
            </li>
            <li className="nav-item">
                <NavLink className="nav-link" to="/players">
                    Players
                </NavLink>
            </li>
        </ul>




<li className="nav-item">
<NavLink className="nav-link" to="/test">
Gallery Item (TEST LINK)
</NavLink>
</li>
 <li>
{(!publicToken && !userAddress)?
<ConnectButton
Tezos={Tezos}
setContract={setContract}
setTokenContract = {setTokenContract}
setPublicToken={setPublicToken}
setWallet={setWallet}
setUserAddress={setUserAddress}
setUserBalance={setUserBalance}
setStorage={setStorage}
setTokenStorage={setTokenStorage}
contractAddress={contractAddress}
tokenContractAddress={tokenContractAddress}
setBeaconConnection={setBeaconConnection}
wallet={wallet}
/>:
<DisconnectButton
wallet={wallet}
setPublicToken={setPublicToken}
setUserAddress={setUserAddress}
setUserBalance={setUserBalance}
setWallet={setWallet}
setTezos={setTezos}
setBeaconConnection={setBeaconConnection}
/>
}
</li> */




